import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/simp_in/step2';
import { PresOffresFNS } from '../models/PresOffresFNS';
@Component({
	selector: 'app-pres-offresFNS',
	templateUrl: './pres-offresFNS.component.html'
})
export class PresOffresFNSComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'PresOffresFNS';
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() presOffres: PresOffresFNS;

	public step2 = new Step2();

	public readonly exigeeValue = 'exigee';
	public readonly autoriseeValue = 'autorisee';
	public readonly interditeValue = 'interdite';

	public radioButtonValue: string;
	public radioButtonCtrlName: string;

	constructor() {}

	public ngOnInit() {
		if (this.presOffres.exigee === '') {
			this.radioButtonValue = this.exigeeValue;
		}
		else if (this.presOffres.autorisee === '') {
			this.radioButtonValue = this.autoriseeValue;
		}
		else {
			this.radioButtonValue = this.interditeValue;
		}
		this.radioButtonCtrlName = this.getUid() + '_SepAtt_exigee';
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
